import { Transform } from 'class-transformer';

export function Filter<T>(criteriaFn: (value: T) => boolean) {
  return Transform(({ value }) => {
    // Return value if value is not array
    if (!Array.isArray(value)) return value;

    // Return value if value is empty
    if (!value.length) return value;

    return value.filter(item => criteriaFn(item));
  });
}
